import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import itemData from "../data";

const initialState = {
  data: [],
  currentCategory: undefined,
  currentSubCategory: undefined,
  searchBy: "",
  hotNewItems: [],
  subCategories: [],
  currentPage: 1,
  itemPerPage: 12,
  cart: [],
  loading: false,
  shipping: "free"
}

export const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload
    },
    nextPage: (state) => {
      state.currentPage += 1;
    },
    previousPage: (state) => {
      state.currentPage -= 1;
    },
    setItemPerPage: (state, action) => {
      // console.log("state ==>", state.itemPerPage);
      // console.log("payload ==> ", action.payload)
      state.currentPage = 1;
      state.itemPerPage = action.payload
    },
    getAllItems: (state) => {
      // console.log("should get items")
      state.hotNewItems = itemData.filter(x => x.tag === "Hot" || x.tag === "New")
      state.data = itemData
    },
    setCategory: (state, action) => {
      state.currentCategory = action.payload
    },
    setSubCategories: (state) => {
      let arr = [];

      state.data.forEach(o => {
        if(o.category === state.currentCategory && arr.indexOf(o.subCategory) < 0) {
          arr.push(o.subCategory)
        }
      })

      state.subCategories = arr
    
    },
    setSearchBy: (state, action) => {
      state.searchBy = action.payload
      let result = itemData;
      // const regex = /[A-Z]/g;
      const regex = new RegExp(action.payload, "gi")
      // const found = paragraph.match(regex);

      
      result = result.filter(x => regex.test(x.name))
      console.log("result ==>", result)
      
      state.data = result
      
    },
    setSubCategory: (state, action) => {
      state.currentSubCategory = action.payload
    },
    getFilteredItems: (state) => {
      
      let result = itemData;
      
      if (state.currentCategory) result = result.filter(x => x.category === state.currentCategory)
      
      // if (state.currentSubCategory || state.currentSubCategory !== "") result = result.filter(x => x.subCategory === state.currentCategory)

      state.data = result;

    },
    addToCart: (state, action) => {
      if(state.cart.length === 0) state.cart = []
      
      let item = state.cart.filter(x => x.id === action.payload)[0]

      if(item) {
        let newQuantity = item.quantity + 1;
        item = {...item, quantity: newQuantity}
        let i = state.cart.findIndex(i => i.id === action.payload)
        state.cart = [...state.cart.slice(0,i), item,...state.cart.slice(i+1)]
      } else {
        let i = state.data.filter(x => x.id === action.payload)[0];
        i = {...i, quantity: 1 };
        state.cart = [...state.cart, i]
      }

    },
    incrementQuantity: (state, action) => {
      let item = state.cart.filter(x => x.id === action.payload)[0]
      let newQuantity = item.quantity + 1;
      item = {...item, quantity: newQuantity}
      let i = state.cart.findIndex(i => i.id === action.payload)
      state.cart = [...state.cart.slice(0,i), item,...state.cart.slice(i+1)]
    },
    decrementQuantity: (state, action) => {
      let item = state.cart.filter(x => x.id === action.payload)[0]
      if(item.quantity === 1) return
      else {
        let newQuantity = item.quantity - 1;
        item = {...item, quantity: newQuantity}
        let i = state.cart.findIndex(i => i.id === action.payload)
        state.cart = [...state.cart.slice(0,i), item,...state.cart.slice(i+1)]
      }

    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(x => x.id !== action.payload)
    },
    clearCart: (state) => {
      state.cart = [];
    },
    setShipping: (state, action) => {
      state.shipping = action.payload;
    }
  }
});


export const {
  setPage, 
  setItemPerPage, 
  getAllItems, 
  setCategory,
  setSubCategory,
  setSubCategories,
  getFilteredItems, 
  addToCart, 
  incrementQuantity, 
  decrementQuantity, 
  removeFromCart,
  nextPage,
  previousPage,
  setShipping,
  clearCart,
  setSearchBy
} = itemSlice.actions

export const selectItems = (state) => state.item.data;
export const selectCategory = (state) => state.item.currentCategory;
export const selectSubCategory = (state) => state.item.currentSubCategory;

export const selectNewHotItems = (state) => state.item.hotNewItems;

export const selectSubCategories = (state) => state.item.subCategories;
export const selectPage = (state) => state.item.currentPage
export const selectItemPerPage = (state) => state.item.itemPerPage;
export const selectLoading = (state) => state.item.loading;
export const selectCart = (state) => state.item.cart; 
export const selectShipping = (state) => state.item.shipping;

export default itemSlice.reducer;